export enum ContactType {
	User = 'User',
	Customer = 'Customer',
	Contact = 'Contact',
}
